module.exports = __webpack_public_path__ + "green.jpg?b8d46bff54e3de51b5e07617084f3a6f";